"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Swiper scroll action.
 */
var SwiperScroll = /*#__PURE__*/function (_EventHandler) {
  _inherits(SwiperScroll, _EventHandler);

  var _super = _createSuper(SwiperScroll);

  /**
   * Class constructor.
   *
   * @param {SwiperInfo} info Swiper info.
   * @param {SwiperRenderer} animation Swiper animation.
   * @param {SwiperPosition} position Swiper position.
   */
  function SwiperScroll(info, animation, position) {
    var _this;

    _classCallCheck(this, SwiperScroll);

    _this = _super.call(this, {
      supportedEvents: ['scrollEnd'],
      componentName: 'Swiper'
    });
    _this.scrollTimeout = 300;
    _this.pageSizeFactor = 0.1; // How much of a page that has to be swiped before it slides to it (number between 0 and 1).

    _this._info = info;
    _this._animation = animation;
    _this._position = position;
    _this._scrollTimeout = null;
    _this._scrollListener = _this._handleScroll.bind(_assertThisInitialized(_this));
    _this._scrollOffset = 0;
    _this._isScrolling = false;
    _this._isConnected = false;
    return _this;
  }
  /**
   * Connects the scroll watcher.
   */


  _createClass(SwiperScroll, [{
    key: "connect",
    value: function connect() {
      if (!this._isConnected && this._info.vertical) {
        this._isConnected = true;

        this._animation.getWrapperElement().addEventListener('mousewheel', this._scrollListener, true);

        this._animation.getWrapperElement().addEventListener('DOMMouseScroll', this._scrollListener, true);
      }
    }
    /**
     * Disconnects the scroll watcher.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this._isConnected) {
        clearTimeout(this._scrollTimeout);
        this._isConnected = false;

        this._animation.getWrapperElement().removeEventListener('mousewheel', this._scrollListener, true);

        this._animation.getWrapperElement().removeEventListener('DOMMouseScroll', this._scrollListener, true);
      }
    }
    /**
     * Resets the state.
     */

  }, {
    key: "reset",
    value: function reset() {
      this._isScrolling = false;
    }
    /**
     * Handle scroll in swiper.
     *
     * @param {Event} event The event.
     */

  }, {
    key: "_handleScroll",
    value: function _handleScroll(event) {
      clearTimeout(this._scrollTimeout);

      if (!this._isConnected || this._position.getPages().length === 0) {
        return;
      }

      event.preventDefault();

      if (!this._isScrolling) {
        this._isScrolling = true;
        this._scrollOffset = -1 * this._position.getPosition();
      }

      var delta = Math.max(-1, Math.min(1, event.wheelDelta || -event.detail));

      var pages = this._position.getPages();

      var totalItemHeight = pages.reduce(function (acc, page) {
        return acc + page.size;
      }, 0);
      var maxScroll = Math.max(0, totalItemHeight - pages[0].size);
      this._scrollOffset += event.deltaY || -50 * delta;
      this._scrollOffset = Math.max(0, Math.min(maxScroll, this._scrollOffset));

      this._animation.cancelTransitions();

      this._animation.setPosition(-1 * this._scrollOffset);

      this._scrollTimeout = setTimeout(window.requestAnimationFrame.bind(window, this._handleScrollEnd.bind(this, delta * -1)), this.scrollTimeout);
    }
    /**
     * Handles scroll end.
     *
     * @param {number} delta Delta (-1 or 1).
     */

  }, {
    key: "_handleScrollEnd",
    value: function _handleScrollEnd(delta) {
      var _this2 = this;

      var position = this._position;
      var newPosition = -1 * this._scrollOffset;

      var getSlidePagePosition = function getSlidePagePosition() {
        return position.getPositionAtPage(position.getPageIndex() + delta) + position.getPageSize(position.getPageIndex() + delta) * (1 - _this2.pageSizeFactor) * delta;
      };

      var isBeginingOrEnd = function isBeginingOrEnd() {
        return delta > 0 ? position.isEnd() : position.isBegining();
      };

      var shouldSlide = function shouldSlide() {
        return delta > 0 ? newPosition < getSlidePagePosition() : newPosition > getSlidePagePosition();
      };

      while (!isBeginingOrEnd() && shouldSlide()) {
        position.slide(delta);
      }

      this._isScrolling = false;

      this._animation.transition();

      this.trigger('scrollEnd');
    }
  }]);

  return SwiperScroll;
}(_EventHandler2.default);

exports.default = SwiperScroll;